import {Component} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {EnumOrderPlacingType, OrderXBVO} from "../model/xbvo.model";
import {RestClient} from "../rest-client.service";
import {DateUtilsBs} from "../base/utils/dateUtilsBs";

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-history>',
    template: `
        <skitbs-template [title]="v('menu_history')">
            <p-table [value]="modelOrders" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Liefertag</th>
                        <th>Tag</th>
                        <th>Menülinie</th>
                        <th>Bestellung</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pOrder>
                    <tr>
                        <td class="TexAlCenter">{{dateFormat(pOrder.serviceDay, 'dd.MM.')}}</td>
                        <td class="TexAlCenter">{{dateFormat(pOrder.serviceDay, 'EE')}}</td>
                        <td class="TexAlCenter">{{pOrder.menuLineDesignation}}</td>
                        <td class="TexAlCenter">{{ve('EnumOrderPlacingType', pOrder.placingType.toString())}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </skitbs-template>
    `
})
export class HistoryComponent extends BaseComponent {


    modelOrders: OrderXBVO[] = [];

    constructor(private restClient: RestClient) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        let pToday = new Date();
        let pStartDate = DateUtilsBs.addDays(pToday, (-6 * 7));
        this.restClient
            .orderHistory(DateUtilsBs.getYear(pStartDate), DateUtilsBs.getWeek(pStartDate))
            .subscribe((aXBVO => this.modelOrders = aXBVO.order));
    }

}
